<template>
    <button v-if="tooLate || done" class="admin-button disabled" :class="class" @click="onClick">
        {{ text }}
    </button>
    <button v-else class="admin-button" :class="class" @click="onClick">
        {{ text }}
    </button>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: true
        },
        done: {
            type: Boolean,
            default: false
        },
        tooLate: {
            type: Boolean,
            default: false
        },
        class: {
            type: String,
            default: ''
        }
    },
    methods: {
        onClick() {
            if (this.done) {
                console.error('This task is already done');
                return;
            } else if (this.tooLate) {
                console.error('This task is too late');
                return;
            }

            // You can emit an event or perform an action here when the button is clicked
            this.$emit('click');
        }
    }
}
</script>
  
<style scoped>
.admin-button {
    width: 21.5em;
    margin-top: 1.1875rem;
    font: 800 1.78125rem;
    text-transform: uppercase;
    color: white;
    background: var(--color-primary);
}

.disabled {
    cursor: not-allowed;
    background-color: lightgray;
    border-color: lightgray;
}
</style>